import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";
import {
    convertCurrencyFormatPositiveNegative,
    convertUniversalDateToPersianDate,
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoLabel,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {HabitationMonitoringService} from "../../../serverService/habitationMonitoring/HabitationMonitoringService";
import React, {useEffect, useState} from "react";
import AreaChartDailyCommuting from "./AreaChartDailyCommuting";


export default function HabitationMonitoringAreaChartDailyCommuting({periodId, refreshFlag = false}) {

    const service = new HabitationMonitoringService()


    const [dailyPopulationData, setDailyPopulationData] = useState([])

    function getDataFromServer() {
        service.getDailyCommutingReport(periodId)
            .then(response => {
                setDailyPopulationData([])
                response.items.map((item, index) => {
                    setDailyPopulationData(prev => [
                        ...prev,
                        {
                            name: convertUniversalDateToPersianDate(item.date),
                            value: item.numberOfEntries,
                            exit: item.numberOfExit,
                            resident: item.numberOfResident,
                        },
                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {

        })
    }

    useEffect(() => {
        if (typeof periodId !== "undefined" && periodId >= 0) {
            getDataFromServer()
        }
    }, [periodId]);

    useEffect(() => {
        if (typeof refreshFlag !== "undefined" && refreshFlag) {
            getDataFromServer()
        }
    }, [refreshFlag]);


    return (
        <RaikoBaseCardContainer className={css`height: 100%;`}>
            <RaikoGridOneColumn className={css`height: 100%;
                grid-auto-rows: auto 1fr;`}>
                <RaikoLabel text={"ورود و خروج روزانه ی اسکان"} className={css`height: fit-content;`}/>
                <AreaChartDailyCommuting dailyCommutingData={dailyPopulationData}/>
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    );
}
